import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {agentLogout} from '@actions/agent';
import {useDispatchAsync} from '@hooks';

function GoOut() {
  const dispatch = useDispatchAsync();
  const navigate = useNavigate();
  useEffect(async () => {
    dispatch(agentLogout());
    return navigate('/org/agent/auth', {replace: true});
  });
  return <></>;
}
export default GoOut;
